import { PropsWithChildren } from "react";

import { FormGlobalError } from "@shared/libs/oh-errors/error-formatter";

import { Notice } from "../Notice";

type Props = {
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
};

const Form = ({ children, ...props }: PropsWithChildren<Props>) => {
  return (
    <form
      {...props}
      onSubmit={e => {
        e.preventDefault();
        props.onSubmit?.(e);
      }}
    >
      {children}
    </form>
  );
};

const GlobalError = ({ globalError }: { globalError?: FormGlobalError | null }) => {
  if (!globalError) return null;
  return <Notice type="red">{globalError.verbose}</Notice>;
};

Form.GlobalError = GlobalError;

export { Form };
